import { useQuery } from 'react-query';

import { axios } from '@/library/axios';

export const getWelcomeBannerDetails = (userId: any): Promise<any> => {
  return axios.get(`/dg/customers/${userId}/gifts/banner`);
};

export const useWelcomeBannerDetails = (userId: any) => {
  return useQuery({
    queryKey: ['welcomeBannerDetails', userId],
    queryFn: () => getWelcomeBannerDetails(userId),
    enabled: !!userId,
    useErrorBoundary: false,
    // Added to update the response to stale with immediate effect
    staleTime: 0,
    // Added to remove the response in the cache
    cacheTime: 0,
    refetchOnMount: 'always',
  });
};
